export enum DraggableType {
    Surgery = "surgery",
    Offer = "offer",
    PotentialPlacement = "potential-placement",
    Unknown = "unknown",
}

export const getDraggableType = (id: string): DraggableType => {
    if (id.startsWith("surgery-")) {
        return DraggableType.Surgery;
    }
    if (id.includes("-offer-")) {
        return DraggableType.Offer;
    }
    if (id.includes("-potential-placement-")) {
        return DraggableType.PotentialPlacement;
    }
    return DraggableType.Unknown;
};
